import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import glover from "../../../assets/judges/glover.jpg";
import austin from "../../../assets/judges/austin.jpg";
import stacey from "../../../assets/judges/stacey.jpg";
import odeh from "../../../assets/judges/odeh.png";
import joseph from "../../../assets/judges/joseph.jpg";

const itemData = [
  {
    img: glover,
    title: "Etemore Glover",
  },
  {
    img: odeh,
    title: "Odeh Friday",
  },
  {
    img: austin,
    title: "Austin Ifedirah",
  },
  {
    img: stacey,
    title: "Stacey Ejiroghene Okparavero",
  },
  {
    img: joseph,
    title: "Joseph Amenaghawon",
  },
];

const Judges = () => {
  const ColorButton = styled(Button)(() => ({
    color: "#049593",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "rgba(0, 0, 0, 0)",
    borderColor: "3px solid #D7A036",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#004165",
      borderColor: "#004165",
    },
  }));

  return (
    <Box paddingTop={{ xs: "25%", sm: "5%" }}>
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant="h3"
          color="#D7A036"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#831312"
            fontWeight={800}
            variant={"h3"}
          >
            The {""}
          </Typography>
          Judges
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignCenter={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "50%" }}
          padding={{ xs: "5% 0%", sm: "1% 3% 3% 0%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={500}
            textAlign={"left"}
            color={"#000"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
            padding={"2% 10% 1% 0%"}
          >
            Our panel of judges consists of a group of respected individuals
            from the community who have demonstrated a commitment to civic
            engagement, leadership, and service. They are from a variety of
            backgrounds with expertise in areas such as community organizing,
            social services, education, business and governance.
          </Typography>
          <Box padding={"5% 2% 1% 0%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              size="medium"
              href={"/our-judges"}
              endIcon={
                <ArrowRightAltIcon
                  sx={{
                    color: "#049593",
                    height: "32px",
                    width: "32px",
                    "&:hover": {
                      color: "#049593",
                    },
                  }}
                />
              }
            >
              View Profiles
            </ColorButton>
          </Box>
        </Box>
        <Box width={{ xs: "100%", sm: "50%" }}>
          <Box sx={{ width: 500, height: 450 }}>
            <ImageList variant="masonry" cols={3} gap={8}>
              {itemData.map((item) => (
                <ImageListItem key={item.img}>
                  <img
                    src={`${item.img}?w=248&fit=crop&auto=format`}
                    srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                    alt={item.title}
                    loading="lazy"
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Judges;
